import {
	cardBackground,
	discount,
	primaryColor,
	pendingColor,
	grayColor,
	dangerColor,
} from 'assets/jss/material-dashboard-pro-react';

const planCardStyle = (theme) => ({
	discountWrapper: {
		display: 'flex',
		'flex-direction': 'row-reverse',
	},
	discountBanner: {
		position: 'absolute',
		display: 'flex',
		width: '75px',
		height: '30px',
		padding: '4px',
		'justify-content': 'center',
		'align-items': 'center',
		gap: '10px',
		'flex-shrink': '0',
		border: `1px solid ${pendingColor}`,
		background: discount,
		'margin-top': '2rem',
		'z-index': 1,
		'border-radius': '4px 0px 0px 4px',
		color: `${grayColor[20]} !important`,
	},
	planCardWrapper: {},
	cardHover: {
		background: 'white',
		border: `3px solid ${primaryColor[0]}`,
		'border-radius': '4px',
		padding: '0 0 16px 0',
	},
	plancard: {
		'min-height': '20vh',
		padding: '4rem 2rem 2rem 2rem',
		'border-radius': '0px',
		'box-shadow': 'none',
		marginTop: '20px',
	},
	customTypo: {
		fontFamily: theme.fontFamily.albert.regular,
		fontSize: theme.fontSize(14),
		lineHeight: theme.fontSize(24),
	},
	originalPrice: {
		color: `${dangerColor[0]} !important`,
		'text-decoration': 'line-through',
		'margin-left': '0.3rem',
	},
	selectButton: {
		'text-transform': 'capitalize',
		height: '40px',
		'& .MuiButton-label': {
			fontFamily: theme.fontFamily.albert.regular,
			fontSize: theme.fontSize(14),
			lineHeight: theme.fontSize(24),
		},
	},
	services: {
		background: cardBackground,
		padding: '2.5rem 0rem 2.5rem 2.5rem',
		'& li': {
			marginBottom: '12px',
		},
	},
	selectedPlan: {
		background: 'white',
		height: '60vh',
		'margin-top': '-1rem',
		border: `3px solid ${primaryColor[0]}`,
	},
	buttonCard: {
		'min-height': '2vh',
		'min-width': '27.3rem',
		padding: '1.5rem',
		'border-radius': '0px',
		'box-shadow': 'none',
		[theme.breakpoints.down('sm')]: {
			'min-width': '0',
		},
	},
	contract: {
		marginTop: '0.5rem',
	},
	priceWrapper: {
		display: 'flex',
		marginTop: '8px',
	},
});

export default planCardStyle;
